// src\pages\RefundPage.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import PolicySwitcher from '../components/ui/policySwitcher';
import { useTranslation } from 'react-i18next';

const RefundContainer = styled(Container)`
  max-width: 800px;
  margin: auto;
  color: #fff;
  border-radius: 8px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const StyledP = styled.p`
  color: #b8b8b8;
  margin-bottom: 0;
`;

const StyledH = styled.h5``;

const StyledLink = styled.a`
  color: #00aaff;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    color: #ffcc00;
    text-decoration: underline;
  }
`;

const SupportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
const SupportEmailMailTo = 'mailto:' + SupportEmail;

const RefundPage = () => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('refundPage.title')} />
      <PolicySwitcher />
      <RefundContainer>
        <Section>
          <StyledH>{t('refundPage.voluntaryDonations.heading')}</StyledH>
          <StyledP>{t('refundPage.voluntaryDonations.text1')}</StyledP>
          <StyledP>{t('refundPage.voluntaryDonations.text2')}</StyledP>
          <StyledP>{t('refundPage.voluntaryDonations.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.virtualContent.heading')}</StyledH>
          <StyledP>{t('refundPage.virtualContent.text1')}</StyledP>
          <StyledP>{t('refundPage.virtualContent.text2')}</StyledP>
          <StyledP>{t('refundPage.virtualContent.text3')}</StyledP>
          <StyledP>
            {t('refundPage.virtualContent.text4')}{' '}
            <StyledLink
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('refundPage.virtualContent.stripePrivacy')}
            </StyledLink>
          </StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.accountSuspension.heading')}</StyledH>
          <StyledP>{t('refundPage.accountSuspension.text1')}</StyledP>
          <StyledP>{t('refundPage.accountSuspension.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.refunds.heading')}</StyledH>
          <StyledP>{t('refundPage.refunds.text1')}</StyledP>
          <StyledP>{t('refundPage.refunds.text2')}</StyledP>
          <StyledP>
            {t('refundPage.refunds.text3')}{' '}
            <StyledLink
              href={SupportEmailMailTo}
            >
              {SupportEmail}
            </StyledLink>
          </StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.exchangeRates.heading')}</StyledH>
          <StyledP>{t('refundPage.exchangeRates.text1')}</StyledP>
          <StyledP>{t('refundPage.exchangeRates.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.thirdParty.heading')}</StyledH>
          <StyledP>{t('refundPage.thirdParty.text1')}</StyledP>
          <StyledP>{t('refundPage.thirdParty.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.fraud.heading')}</StyledH>
          <StyledP>{t('refundPage.fraud.text1')}</StyledP>
          <StyledP>{t('refundPage.fraud.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.policyChanges.heading')}</StyledH>
          <StyledP>{t('refundPage.policyChanges.text1')}</StyledP>
          <StyledP>{t('refundPage.policyChanges.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.virtualCurrencyDisclaimer.heading')}</StyledH>
          <StyledP>{t('refundPage.virtualCurrencyDisclaimer.text1')}</StyledP>
          <StyledP>{t('refundPage.virtualCurrencyDisclaimer.text2')}</StyledP>
          <StyledP>{t('refundPage.virtualCurrencyDisclaimer.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('refundPage.noRefund.heading')}</StyledH>
          <StyledP>{t('refundPage.noRefund.text1')}</StyledP>
          <StyledP>{t('refundPage.noRefund.text2')}</StyledP>
          <StyledP>{t('refundPage.noRefund.text3')}</StyledP>
          <StyledP>{t('refundPage.noRefund.text4')}</StyledP>
          <StyledP>
            {t('refundPage.noRefund.text5')}{' '}
            <StyledLink href={SupportEmailMailTo}>
              {SupportEmail}
            </StyledLink>
          </StyledP>
        </Section>
      </RefundContainer>
    </PageContentComponent>
  );
};

export default RefundPage;
